/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  GetCashDeclarationResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cash declaration history by declarationID
 * @summary Get cash declaration history by declarationID
 */
export const getCashDeclarationHistoryId = (declarationID: string, signal?: AbortSignal) => {
  return customInstance<GetCashDeclarationResponseResponse>({
    url: `/BboCashManagementService/v1/cash-declaration/history/${declarationID}`,
    method: 'get',
    signal,
  });
};

export const getGetCashDeclarationHistoryIdQueryKey = (declarationID: string) => {
  return [`/BboCashManagementService/v1/cash-declaration/history/${declarationID}`] as const;
};

export const getGetCashDeclarationHistoryIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistoryId>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  declarationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistoryId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashDeclarationHistoryIdQueryKey(declarationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashDeclarationHistoryId>>> = ({
    signal,
  }) => getCashDeclarationHistoryId(declarationID, signal);

  return { queryKey, queryFn, enabled: !!declarationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashDeclarationHistoryId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashDeclarationHistoryIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashDeclarationHistoryId>>
>;
export type GetCashDeclarationHistoryIdQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get cash declaration history by declarationID
 */
export const useGetCashDeclarationHistoryId = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistoryId>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  declarationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistoryId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashDeclarationHistoryIdQueryOptions(declarationID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
